import { Box } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC } from 'react';

import { CategoriesList } from '../../common/components/CategoriesList';
import { Loader } from '../../common/components/Loader';
import { useAnimation } from '../../common/hooks/useAnimation';
import { useCategories } from '../../common/hooks/useCategories';
import { Subtitle } from '../../help-center/components/Subtitle';
import { TLocalesKeys } from '../../types';
import s from './styles.scss';

export const Categories: FC = () => {
  const { t } = useTranslation();
  const { categories } = useCategories();
  const activeAnimation = useAnimation(s.moveInRight, s.moveInLeft, []);

  if (!categories?.length) {
    return <Loader height="100%" width="100%" verticalAlign="middle" />;
  }
  return (
    <Box
      dataHook="categories-page"
      className={activeAnimation}
      direction="vertical"
      height="100%"
    >
      <Subtitle
        hideBackButton
        text={t<TLocalesKeys>('help-center-home-categories-title')}
      />
      <CategoriesList categories={categories} />
    </Box>
  );
};
